/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductModelPoints } from './ProductModelPoints';
import {
    ProductModelPointsFromJSON,
    ProductModelPointsFromJSONTyped,
    ProductModelPointsToJSON,
} from './ProductModelPoints';

/**
 * 決済を行う商品
 * @export
 * @interface ProductModel
 */
export interface ProductModel {
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    type: ProductModelTypeEnum;
    /**
     * 商品名
     * @type {string}
     * @memberof ProductModel
     */
    name: string;
    /**
     * 金額
     * @type {number}
     * @memberof ProductModel
     */
    price: number;
    /**
     * 通貨コード
     * @type {string}
     * @memberof ProductModel
     */
    currency: string;
    /**
     * この商品を購入するために利用可能な支払い方法
     * @type {Array<string>}
     * @memberof ProductModel
     */
    paymentMethods: Array<ProductModelPaymentMethodsEnum>;
    /**
     * 
     * @type {ProductModelPoints}
     * @memberof ProductModel
     */
    points?: ProductModelPoints;
}


/**
 * @export
 */
export const ProductModelTypeEnum = {
    Coin: 'coin'
} as const;
export type ProductModelTypeEnum = typeof ProductModelTypeEnum[keyof typeof ProductModelTypeEnum];

/**
 * @export
 */
export const ProductModelPaymentMethodsEnum = {
    Stripe: 'stripe'
} as const;
export type ProductModelPaymentMethodsEnum = typeof ProductModelPaymentMethodsEnum[keyof typeof ProductModelPaymentMethodsEnum];


/**
 * Check if a given object implements the ProductModel interface.
 */
export function instanceOfProductModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "paymentMethods" in value;

    return isInstance;
}

export function ProductModelFromJSON(json: any): ProductModel {
    return ProductModelFromJSONTyped(json, false);
}

export function ProductModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'name': json['name'],
        'price': json['price'],
        'currency': json['currency'],
        'paymentMethods': json['paymentMethods'],
        'points': !exists(json, 'points') ? undefined : ProductModelPointsFromJSON(json['points']),
    };
}

export function ProductModelToJSON(value?: ProductModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'name': value.name,
        'price': value.price,
        'currency': value.currency,
        'paymentMethods': value.paymentMethods,
        'points': ProductModelPointsToJSON(value.points),
    };
}

